<div class="option-modal">
    <section class="head">
        <article class="subtitle">{{ 'SHARED_COMPONENT.RESERVATION' | translate }}</article>
        <button mat-icon-button mat-dialog-close [disabled]="isLoading">
            <mat-icon>close</mat-icon>
        </button>
    </section>

    <div style="display: contents">
        @switch (currentViewType) {
            @case ('loading') {
                <section class="loading">
                    <loading-indicator [isPermanent]="true" [isEmbedded]="true" />
                </section>
            }
            @case ('finish') {
                <section class="finish">
                    <ak-message-box [type]="warningBoxType">
                        {{ messageKey | translate }}
                    </ak-message-box>
                </section>
            }
        }
    </div>

    @if (currentViewType === 'finish') {
        <section class="actions">
            <button matButton="outlined" mat-dialog-close>{{ 'SHARED_COMPONENT.CLOSE' | translate }}</button>
        </section>
    }
</div>
